import { api, getServiceConfig } from 'utility';
import {
  getSwitchUrl,
  getMenusUrl,
  getPermissionUrl,
  getHistoryVersionsUrl,
  agreeVersion,
} from 'URLs';
const source = api.cancelToken;
let cancelToken;

export function getTestPanelUrl() {
  return api.get(getSwitchUrl()).then((res) => res.data);
}
export async function getMenus() {
  const configBaseUrl = await getServiceConfig();
  const baseUrlDefault = process.env?.REACT_APP_API_JAVA
    ? `${process.env.REACT_APP_API_JAVA}${process.env.REACT_APP_BASE_URL}`
    : `${process.env.REACT_APP_BASE_URL}`;

  // Set dynamic base URL for axios
  api.axios.defaults.baseURL = configBaseUrl?.result?.baseUrl || baseUrlDefault;
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();

  return api
    .get(getMenusUrl(), {
      cancelToken: cancelToken.token,
    })
    .then((res) => res.data);
}
export async function getPermissions() {
  return api.get(getPermissionUrl()).then((res) => res.data);
}

export function postAgreeVersion(version) {
  return api.post(agreeVersion(version)).then((res) => res.data);
}
/**
 * دریافت لیست تاریخچه تغییرات و ورژن ها
 */
export async function getHistoryVersions() {
  return api.get(getHistoryVersionsUrl()).then((res) => res.data);
}

export default {
  getTestPanelUrl,
  getMenus,
  getPermissions,
  getHistoryVersions,
  postAgreeVersion,
};
